import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import { GlobalContext } from "../Context/GlobalContext";

const VerifyOtpModal = ({ show, email, onClose, onSuccess }) => {
  const {
    userData,
    updateUserData,
    fourLifeVerifyOTP,
    fourLiferesendOTP,
    timer,
    resendDisabled,
    translatedLabels,
  } = useContext(GlobalContext);

  const authLabel = translatedLabels?.auth;

  const handleVerify = async () => {
    const res = await fourLifeVerifyOTP({
      secondaryemail: email,
      module: "Signup",
    });
    if (res?.status) {
      onSuccess();
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          {authLabel?.verification_code?.label_value || "Verification Code"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        <p>
          {authLabel?.your_email?.label_value || "Your Email"}: <b>{email}</b>
        </p>

        <p className="text-muted">
          {authLabel?.enter_email_code?.label_value ||
            "Enter 6-digit code sent to your email"}
        </p>

        <div className="otp-container my-3">
          <input
            type="text"
            maxLength="6"
            className="otp-input"
            value={userData.otp}
            onChange={(e) => {
              const value = e.target.value;

              if (/^\d*$/.test(value)) {
                updateUserData("otp", value);
              }
            }}
            inputMode="numeric"
            pattern="[0-9]*"
          />
        </div>

        <p>
          {authLabel?.didnt_receive_code?.label_value ||
            "Didn’t receive the code?"}
          <span
            onClick={() => {
              if (resendDisabled) return;
              fourLiferesendOTP({ email, module: "Signup" });
            }}
            className="ms-1"
            style={{
              cursor: resendDisabled ? "not-allowed" : "pointer",
              color: resendDisabled ? "gray" : "blue",
              pointerEvents: resendDisabled ? "none" : "auto",
            }}
          >
            {authLabel?.resend?.label_value || "Resend"}
          </span>
        </p>

        {resendDisabled && (
          <p>
            {authLabel?.resend_otp_in?.label_value || "Resend in"} 00:
            {timer < 10 ? `0${timer}` : timer}
          </p>
        )}
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <button className="btn btn-primary" onClick={handleVerify}>
          {authLabel?.verify?.label_value || "Verify"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default VerifyOtpModal;
